"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ['ar', 'hr', 'fr', 'es', 'mt', 'bg', 'zh', 'it', 'ko', 'uk', 'lv', 'da', 'vi', 'en', 'sr', 'sv', 'pt', 'sk', 'hi', 'ga', 'fi', 'et', 'cs', 'el', 'hu', 'id', 'ja', 'be', 'is', 'pl', 'tr', 'ca', 'ms', 'lt', 'sq', 'de', 'ro', 'sl', 'ru', 'nn', 'th', 'mk', 'he', 'nl', 'no'];
exports.default = _default;
module.exports = exports.default;